import _ from 'lodash';
import React from 'react';

import SwipeableViews from 'react-swipeable-views';

import * as XLayout from '@pitaman71/react-explicit-layout';

import { Styler } from '.';

let logEnable: boolean = true;

export default function(props: React.PropsWithChildren<{
    selected: number,
    setSelected: (selected_: number) => void
}>) {
    return (
        <SwipeableViews
            axis={'x'}
            index={props.selected}
            onChangeIndex={props.setSelected}
            enableMouseEvents
            style={{ maxWidth: '100%', maxHeight: '100%' }}
        >
            {
                React.Children.map(props.children, item => {
                    return <Styler.Card prefix="carousel-item" style={{ flex: `0 0 auto`, width: '100%', height: '100%' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
                            {item}
                        </div>
                    </Styler.Card>
                })
            }
        </SwipeableViews>
    );
}
